<div class="page-content full-screen">
  <div class="theme-panel-img"></div>

  <div class="middle-panel">
    <router-outlet></router-outlet>
  </div>
</div>
<div class="footer-section">
  <p class="footer">
    &copy; {{ year }} {{ env.copyRight }}
    <app-version-tag></app-version-tag>
  </p>
</div>
